module.exports = __webpack_public_path__ + "static/1-05576e04d6abd1ba96430a2fd35ea653.mp4";